import request from '../utils/request'

export function noticeList(params) { // 我的消息列表
    return request({
        url: '/notice/index',
        method: 'GET',
        params
    })
}

export function noticeDetail(params) { // 消息详情
    return request({
        url: '/notice/info',
        method: 'GET',
        params
    })
}

export function noticeDelete(data) { // 删除消息
    return request({
        url: '/notice/del',
        method: 'POST',
        data
    })
}
